import { JoiningPropertyModel } from "../../../../../../../../models/queries/queries.models";
import { BaseQueryBuilder } from "./base-query-builder";
import { LookupClientService } from "../../../../../../../../services/lookups/lookup-client.service";
import { CustomerService } from "../../../../../../../../services/modules/customer-client.service";
import { ManageRightShipUsersClientService } from "../../../../../../../../services/modules/righship-qi-manage-users.service";
import { autoinject, computedFrom, transient } from "aurelia-framework";
import { Reflection } from "../../../../../../../../utilities/reflection";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";

class ListQueryFilter {
    in: boolean;
    listId: number;
    businessUnitId: number;
    customerId: number;
    listGroupId: number;
    isInGroup: boolean;
    doNotConsiderEffectiveDates: boolean;
    effectiveFrom: Date;
    effectiveTo: Date;
    joiningClause: JoiningPropertyModel;
}

@autoinject
@transient()
export class VettingrulelistitemsQueryBuilder extends BaseQueryBuilder<ListQueryFilter> {
 
    constructor(lookupService: LookupClientService, customerService: CustomerService,
        manageRightShipUsersClientService: ManageRightShipUsersClientService, configService: ConfigService) {
        super(lookupService, customerService, manageRightShipUsersClientService, configService);
    }

    @computedFrom(Reflection.getPropertyPath<VettingrulelistitemsQueryBuilder>(z => z.filter.joiningClause.friendlyName))
    get isCompany() : boolean {
        return this.filter.joiningClause.friendlyName != "Vessel";
    }
    
    itemSource: { name: string; value: boolean; }[] = [
        {name: "in", value: true},
        {name: "not in", value: false}
    ];
}